import * as z from "zod/v4";
import {
  getSelfServeOnboardingFunnelStats,
  selfServeOnboardingFunnelStatsSchema,
} from "../onboardings/get-self-serve-onboarding-funnel-stats";
import { onboardingV2AnalyticsProductInputSchema } from "./analytics-product-id";

export const getOnboardingsV2FunnelStats = {
  name: "getOnboardingsV2FunnelStats" as const,
  input: z.intersection(
    getSelfServeOnboardingFunnelStats.input,
    onboardingV2AnalyticsProductInputSchema,
  ),
  output: selfServeOnboardingFunnelStatsSchema,
};

export type GetOnboardingsV2FunnelStatsInput = z.infer<
  typeof getOnboardingsV2FunnelStats.input
>;
export type GetOnboardingsV2FunnelStatsOutput = z.infer<
  typeof getOnboardingsV2FunnelStats.output
>;
